/**
 * Phone OTP countries. United States is first (app default);
 * remaining entries stay alphabetical by name.
 */
export const COUNTRIES = [
  { iso: "US", name: "United States", dialCode: "1" },
  { iso: "AF", name: "Afghanistan", dialCode: "93" },
  { iso: "AL", name: "Albania", dialCode: "355" },
  { iso: "DZ", name: "Algeria", dialCode: "213" },
  { iso: "AS", name: "American Samoa", dialCode: "1684" },
  { iso: "AD", name: "Andorra", dialCode: "376" },
  { iso: "AO", name: "Angola", dialCode: "244" },
  { iso: "AI", name: "Anguilla", dialCode: "1264" },
  { iso: "AG", name: "Antigua and Barbuda", dialCode: "1268" },
  { iso: "AR", name: "Argentina", dialCode: "54" },
  { iso: "AM", name: "Armenia", dialCode: "374" },
  { iso: "AW", name: "Aruba", dialCode: "297" },
  { iso: "AU", name: "Australia", dialCode: "61" },
  { iso: "AT", name: "Austria", dialCode: "43" },
  { iso: "AZ", name: "Azerbaijan", dialCode: "994" },
  { iso: "BS", name: "Bahamas", dialCode: "1242" },
  { iso: "BH", name: "Bahrain", dialCode: "973" },
  { iso: "BD", name: "Bangladesh", dialCode: "880" },
  { iso: "BB", name: "Barbados", dialCode: "1246" },
  { iso: "BY", name: "Belarus", dialCode: "375" },
  { iso: "BE", name: "Belgium", dialCode: "32" },
  { iso: "BZ", name: "Belize", dialCode: "501" },
  { iso: "BJ", name: "Benin", dialCode: "229" },
  { iso: "BM", name: "Bermuda", dialCode: "1441" },
  { iso: "BT", name: "Bhutan", dialCode: "975" },
  { iso: "BO", name: "Bolivia", dialCode: "591" },
  { iso: "BA", name: "Bosnia and Herzegovina", dialCode: "387" },
  { iso: "BW", name: "Botswana", dialCode: "267" },
  { iso: "BR", name: "Brazil", dialCode: "55" },
  { iso: "IO", name: "British Indian Ocean Territory", dialCode: "246" },
  { iso: "VG", name: "British Virgin Islands", dialCode: "1284" },
  { iso: "BN", name: "Brunei", dialCode: "673" },
  { iso: "BG", name: "Bulgaria", dialCode: "359" },
  { iso: "BF", name: "Burkina Faso", dialCode: "226" },
  { iso: "BI", name: "Burundi", dialCode: "257" },
  { iso: "KH", name: "Cambodia", dialCode: "855" },
  { iso: "CM", name: "Cameroon", dialCode: "237" },
  { iso: "CA", name: "Canada", dialCode: "1" },
  { iso: "CV", name: "Cape Verde", dialCode: "238" },
  { iso: "KY", name: "Cayman Islands", dialCode: "1345" },
  { iso: "CF", name: "Central African Republic", dialCode: "236" },
  { iso: "TD", name: "Chad", dialCode: "235" },
  { iso: "CL", name: "Chile", dialCode: "56" },
  { iso: "CN", name: "China", dialCode: "86" },
  { iso: "CO", name: "Colombia", dialCode: "57" },
  { iso: "KM", name: "Comoros", dialCode: "269" },
  { iso: "CG", name: "Congo", dialCode: "242" },
  { iso: "CD", name: "Congo (DRC)", dialCode: "243" },
  { iso: "CK", name: "Cook Islands", dialCode: "682" },
  { iso: "CR", name: "Costa Rica", dialCode: "506" },
  { iso: "CI", name: "Côte d’Ivoire", dialCode: "225" },
  { iso: "HR", name: "Croatia", dialCode: "385" },
  { iso: "CU", name: "Cuba", dialCode: "53" },
  { iso: "CW", name: "Curaçao", dialCode: "599" },
  { iso: "CY", name: "Cyprus", dialCode: "357" },
  { iso: "CZ", name: "Czech Republic", dialCode: "420" },
  { iso: "DK", name: "Denmark", dialCode: "45" },
  { iso: "DJ", name: "Djibouti", dialCode: "253" },
  { iso: "DM", name: "Dominica", dialCode: "1767" },
  { iso: "DO", name: "Dominican Republic", dialCode: "1809" },
  { iso: "EC", name: "Ecuador", dialCode: "593" },
  { iso: "EG", name: "Egypt", dialCode: "20" },
  { iso: "SV", name: "El Salvador", dialCode: "503" },
  { iso: "GQ", name: "Equatorial Guinea", dialCode: "240" },
  { iso: "ER", name: "Eritrea", dialCode: "291" },
  { iso: "EE", name: "Estonia", dialCode: "372" },
  { iso: "ET", name: "Ethiopia", dialCode: "251" },
  { iso: "FK", name: "Falkland Islands", dialCode: "500" },
  { iso: "FO", name: "Faroe Islands", dialCode: "298" },
  { iso: "FJ", name: "Fiji", dialCode: "679" },
  { iso: "FI", name: "Finland", dialCode: "358" },
  { iso: "FR", name: "France", dialCode: "33" },
  { iso: "GF", name: "French Guiana", dialCode: "594" },
  { iso: "PF", name: "French Polynesia", dialCode: "689" },
  { iso: "GA", name: "Gabon", dialCode: "241" },
  { iso: "GM", name: "Gambia", dialCode: "220" },
  { iso: "GE", name: "Georgia", dialCode: "995" },
  { iso: "DE", name: "Germany", dialCode: "49" },
  { iso: "GH", name: "Ghana", dialCode: "233" },
  { iso: "GI", name: "Gibraltar", dialCode: "350" },
  { iso: "GR", name: "Greece", dialCode: "30" },
  { iso: "GL", name: "Greenland", dialCode: "299" },
  { iso: "GD", name: "Grenada", dialCode: "1473" },
  { iso: "GP", name: "Guadeloupe", dialCode: "590" },
  { iso: "GU", name: "Guam", dialCode: "1671" },
  { iso: "GT", name: "Guatemala", dialCode: "502" },
  { iso: "GG", name: "Guernsey", dialCode: "44" },
  { iso: "GN", name: "Guinea", dialCode: "224" },
  { iso: "GW", name: "Guinea-Bissau", dialCode: "245" },
  { iso: "GY", name: "Guyana", dialCode: "592" },
  { iso: "HT", name: "Haiti", dialCode: "509" },
  { iso: "HN", name: "Honduras", dialCode: "504" },
  { iso: "HK", name: "Hong Kong", dialCode: "852" },
  { iso: "HU", name: "Hungary", dialCode: "36" },
  { iso: "IS", name: "Iceland", dialCode: "354" },
  { iso: "IN", name: "India", dialCode: "91" },
  { iso: "ID", name: "Indonesia", dialCode: "62" },
  { iso: "IR", name: "Iran", dialCode: "98" },
  { iso: "IQ", name: "Iraq", dialCode: "964" },
  { iso: "IE", name: "Ireland", dialCode: "353" },
  { iso: "IM", name: "Isle of Man", dialCode: "44" },
  { iso: "IL", name: "Israel", dialCode: "972" },
  { iso: "IT", name: "Italy", dialCode: "39" },
  { iso: "JM", name: "Jamaica", dialCode: "1876" },
  { iso: "JP", name: "Japan", dialCode: "81" },
  { iso: "JE", name: "Jersey", dialCode: "44" },
  { iso: "JO", name: "Jordan", dialCode: "962" },
  { iso: "KZ", name: "Kazakhstan", dialCode: "7" },
  { iso: "KE", name: "Kenya", dialCode: "254" },
  { iso: "KI", name: "Kiribati", dialCode: "686" },
  { iso: "KW", name: "Kuwait", dialCode: "965" },
  { iso: "KG", name: "Kyrgyzstan", dialCode: "996" },
  { iso: "LA", name: "Laos", dialCode: "856" },
  { iso: "LV", name: "Latvia", dialCode: "371" },
  { iso: "LB", name: "Lebanon", dialCode: "961" },
  { iso: "LS", name: "Lesotho", dialCode: "266" },
  { iso: "LR", name: "Liberia", dialCode: "231" },
  { iso: "LY", name: "Libya", dialCode: "218" },
  { iso: "LI", name: "Liechtenstein", dialCode: "423" },
  { iso: "LT", name: "Lithuania", dialCode: "370" },
  { iso: "LU", name: "Luxembourg", dialCode: "352" },
  { iso: "MO", name: "Macau", dialCode: "853" },
  { iso: "MK", name: "North Macedonia", dialCode: "389" },
  { iso: "MG", name: "Madagascar", dialCode: "261" },
  { iso: "MW", name: "Malawi", dialCode: "265" },
  { iso: "MY", name: "Malaysia", dialCode: "60" },
  { iso: "MV", name: "Maldives", dialCode: "960" },
  { iso: "ML", name: "Mali", dialCode: "223" },
  { iso: "MT", name: "Malta", dialCode: "356" },
  { iso: "MH", name: "Marshall Islands", dialCode: "692" },
  { iso: "MQ", name: "Martinique", dialCode: "596" },
  { iso: "MR", name: "Mauritania", dialCode: "222" },
  { iso: "MU", name: "Mauritius", dialCode: "230" },
  { iso: "MX", name: "Mexico", dialCode: "52" },
  { iso: "FM", name: "Micronesia", dialCode: "691" },
  { iso: "MD", name: "Moldova", dialCode: "373" },
  { iso: "MC", name: "Monaco", dialCode: "377" },
  { iso: "MN", name: "Mongolia", dialCode: "976" },
  { iso: "ME", name: "Montenegro", dialCode: "382" },
  { iso: "MS", name: "Montserrat", dialCode: "1664" },
  { iso: "MA", name: "Morocco", dialCode: "212" },
  { iso: "MZ", name: "Mozambique", dialCode: "258" },
  { iso: "MM", name: "Myanmar", dialCode: "95" },
  { iso: "NA", name: "Namibia", dialCode: "264" },
  { iso: "NR", name: "Nauru", dialCode: "674" },
  { iso: "NP", name: "Nepal", dialCode: "977" },
  { iso: "NL", name: "Netherlands", dialCode: "31" },
  { iso: "NC", name: "New Caledonia", dialCode: "687" },
  { iso: "NZ", name: "New Zealand", dialCode: "64" },
  { iso: "NI", name: "Nicaragua", dialCode: "505" },
  { iso: "NE", name: "Niger", dialCode: "227" },
  { iso: "NG", name: "Nigeria", dialCode: "234" },
  { iso: "NU", name: "Niue", dialCode: "683" },
  { iso: "NF", name: "Norfolk Island", dialCode: "672" },
  { iso: "KP", name: "North Korea", dialCode: "850" },
  { iso: "MP", name: "Northern Mariana Islands", dialCode: "1670" },
  { iso: "NO", name: "Norway", dialCode: "47" },
  { iso: "OM", name: "Oman", dialCode: "968" },
  { iso: "PK", name: "Pakistan", dialCode: "92" },
  { iso: "PW", name: "Palau", dialCode: "680" },
  { iso: "PS", name: "Palestine", dialCode: "970" },
  { iso: "PA", name: "Panama", dialCode: "507" },
  { iso: "PG", name: "Papua New Guinea", dialCode: "675" },
  { iso: "PY", name: "Paraguay", dialCode: "595" },
  { iso: "PE", name: "Peru", dialCode: "51" },
  { iso: "PH", name: "Philippines", dialCode: "63" },
  { iso: "PL", name: "Poland", dialCode: "48" },
  { iso: "PT", name: "Portugal", dialCode: "351" },
  { iso: "PR", name: "Puerto Rico", dialCode: "1787" },
  { iso: "QA", name: "Qatar", dialCode: "974" },
  { iso: "RE", name: "Réunion", dialCode: "262" },
  { iso: "RO", name: "Romania", dialCode: "40" },
  { iso: "RU", name: "Russia", dialCode: "7" },
  { iso: "RW", name: "Rwanda", dialCode: "250" },
  { iso: "BL", name: "Saint Barthélemy", dialCode: "590" },
  { iso: "SH", name: "Saint Helena", dialCode: "290" },
  { iso: "KN", name: "Saint Kitts and Nevis", dialCode: "1869" },
  { iso: "LC", name: "Saint Lucia", dialCode: "1758" },
  { iso: "MF", name: "Saint Martin", dialCode: "590" },
  { iso: "PM", name: "Saint Pierre and Miquelon", dialCode: "508" },
  { iso: "VC", name: "Saint Vincent and the Grenadines", dialCode: "1784" },
  { iso: "WS", name: "Samoa", dialCode: "685" },
  { iso: "SM", name: "San Marino", dialCode: "378" },
  { iso: "ST", name: "São Tomé and Príncipe", dialCode: "239" },
  { iso: "SA", name: "Saudi Arabia", dialCode: "966" },
  { iso: "SN", name: "Senegal", dialCode: "221" },
  { iso: "RS", name: "Serbia", dialCode: "381" },
  { iso: "SC", name: "Seychelles", dialCode: "248" },
  { iso: "SL", name: "Sierra Leone", dialCode: "232" },
  { iso: "SG", name: "Singapore", dialCode: "65" },
  { iso: "SX", name: "Sint Maarten", dialCode: "1721" },
  { iso: "SK", name: "Slovakia", dialCode: "421" },
  { iso: "SI", name: "Slovenia", dialCode: "386" },
  { iso: "SB", name: "Solomon Islands", dialCode: "677" },
  { iso: "SO", name: "Somalia", dialCode: "252" },
  { iso: "ZA", name: "South Africa", dialCode: "27" },
  { iso: "KR", name: "South Korea", dialCode: "82" },
  { iso: "SS", name: "South Sudan", dialCode: "211" },
  { iso: "ES", name: "Spain", dialCode: "34" },
  { iso: "LK", name: "Sri Lanka", dialCode: "94" },
  { iso: "SD", name: "Sudan", dialCode: "249" },
  { iso: "SR", name: "Suriname", dialCode: "597" },
  { iso: "SZ", name: "Eswatini", dialCode: "268" },
  { iso: "SE", name: "Sweden", dialCode: "46" },
  { iso: "CH", name: "Switzerland", dialCode: "41" },
  { iso: "SY", name: "Syria", dialCode: "963" },
  { iso: "TW", name: "Taiwan", dialCode: "886" },
  { iso: "TJ", name: "Tajikistan", dialCode: "992" },
  { iso: "TZ", name: "Tanzania", dialCode: "255" },
  { iso: "TH", name: "Thailand", dialCode: "66" },
  { iso: "TL", name: "Timor-Leste", dialCode: "670" },
  { iso: "TG", name: "Togo", dialCode: "228" },
  { iso: "TK", name: "Tokelau", dialCode: "690" },
  { iso: "TO", name: "Tonga", dialCode: "676" },
  { iso: "TT", name: "Trinidad and Tobago", dialCode: "1868" },
  { iso: "TN", name: "Tunisia", dialCode: "216" },
  { iso: "TR", name: "Turkey", dialCode: "90" },
  { iso: "TM", name: "Turkmenistan", dialCode: "993" },
  { iso: "TC", name: "Turks and Caicos Islands", dialCode: "1649" },
  { iso: "TV", name: "Tuvalu", dialCode: "688" },
  { iso: "VI", name: "U.S. Virgin Islands", dialCode: "1340" },
  { iso: "UG", name: "Uganda", dialCode: "256" },
  { iso: "UA", name: "Ukraine", dialCode: "380" },
  { iso: "AE", name: "United Arab Emirates", dialCode: "971" },
  { iso: "GB", name: "United Kingdom", dialCode: "44" },
  { iso: "UY", name: "Uruguay", dialCode: "598" },
  { iso: "UZ", name: "Uzbekistan", dialCode: "998" },
  { iso: "VU", name: "Vanuatu", dialCode: "678" },
  { iso: "VA", name: "Vatican City", dialCode: "39" },
  { iso: "VE", name: "Venezuela", dialCode: "58" },
  { iso: "VN", name: "Vietnam", dialCode: "84" },
  { iso: "WF", name: "Wallis and Futuna", dialCode: "681" },
  { iso: "YE", name: "Yemen", dialCode: "967" },
  { iso: "ZM", name: "Zambia", dialCode: "260" },
  { iso: "ZW", name: "Zimbabwe", dialCode: "263" },
];

export const DEFAULT_COUNTRY_ISO = "US";

export const DEFAULT_COUNTRY =
  COUNTRIES.find((c) => c.iso === DEFAULT_COUNTRY_ISO) ?? COUNTRIES[0];

/** Flag image URL — emoji flags render as "US"/"AF" text on Windows. */
export function getCountryFlagSrc(iso, width = 20) {
  const code = iso.toLowerCase().replace(/[^a-z]/g, "").slice(0, 2);
  return `https://flagcdn.com/w${width}/${code}.png`;
}

/** Longest dial-code match first so +1684 beats +1, etc. */
const COUNTRIES_BY_DIAL = [...COUNTRIES].sort(
  (a, b) => b.dialCode.length - a.dialCode.length
);

export function findCountryByIso(iso) {
  if (!iso) return DEFAULT_COUNTRY;
  return COUNTRIES.find((c) => c.iso === iso.toUpperCase()) ?? DEFAULT_COUNTRY;
}

/**
 * Split an E.164-ish value into country + national digits.
 * Prefers US when dial code is shared (e.g. +1).
 */
export function parsePhoneWithCountry(
  raw,
  preferredIso = DEFAULT_COUNTRY_ISO
) {
  const trimmed = raw.trim();
  if (!trimmed) {
    return { country: findCountryByIso(preferredIso), nationalNumber: "" };
  }

  const digits = (trimmed.startsWith("+") ? trimmed.slice(1) : trimmed).replace(
    /\D/g,
    ""
  );
  if (!digits) {
    return { country: findCountryByIso(preferredIso), nationalNumber: "" };
  }

  const preferred = findCountryByIso(preferredIso);
  if (digits.startsWith(preferred.dialCode)) {
    return {
      country: preferred,
      nationalNumber: digits.slice(preferred.dialCode.length),
    };
  }

  for (const country of COUNTRIES_BY_DIAL) {
    if (digits.startsWith(country.dialCode)) {
      if (country.dialCode === "1") {
        return {
          country: DEFAULT_COUNTRY,
          nationalNumber: digits.slice(1),
        };
      }
      return {
        country,
        nationalNumber: digits.slice(country.dialCode.length),
      };
    }
  }

  return {
    country: findCountryByIso(preferredIso),
    nationalNumber: digits,
  };
}

export function buildE164Phone(country, nationalNumber) {
  // Strip trunk prefix zeros (e.g. 0301… → 301…) before building E.164.
  const national = nationalNumber.replace(/\D/g, "").replace(/^0+/, "");
  if (!national) return "";
  return `+${country.dialCode}${national}`;
}
